import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';

import { PreviewGateService } from '../../services/preview-gate.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-preview-gate',
    templateUrl: './preview-gate.component.html',
    styleUrls: ['./preview-gate.component.scss'],
    standalone: false
})
export class PreviewGateComponent implements OnInit, AfterViewInit {
  @ViewChild('usernameInput') usernameInputEl: ElementRef<HTMLInputElement>;

  gateForm: FormGroup;
  checking = false;
  invalidCredentials = false;
  unexpectedError = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly previewGateService: PreviewGateService
  ) {
  }

  ngOnInit() {
    this.gateForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngAfterViewInit() {
    this.usernameInputEl?.nativeElement?.focus();
  }

  onSubmit() {
    if (this.checking) {
      return;
    }

    this.invalidCredentials = false;
    this.unexpectedError = false;

    if (this.gateForm.invalid) {
      this.gateForm.markAllAsTouched();
      return;
    }

    const { username, password } = this.gateForm.value;

    this.checking = true;
    this.changeDetectorRef.markForCheck();

    this.previewGateService.unlock(username, password)
      .pipe(take(1))
      .subscribe({
        next: (unlocked: boolean) => {
          this.checking = false;

          if (!unlocked) {
            this.invalidCredentials = true;
            this.gateForm.get('password').reset();
            this.changeDetectorRef.markForCheck();
            return;
          }

          // Reloads so the guarded route (blocked before the gate was unlocked) is re-evaluated.
          location.reload();
        },
        error: () => {
          this.checking = false;
          this.unexpectedError = true;
          this.changeDetectorRef.markForCheck();
        }
      });
  }
}

